import { forwardRef } from 'react';

/**
 * Amount entry.
 *
 * inputmode="decimal" on a type="text" field, NOT type="number":
 *  - type=number renders spinner arrows nobody wants on a phone,
 *  - it rejects a pasted "1,234.56" outright,
 *  - and valueAsNumber misreports locale input.
 * inputmode gets the numeric keypad without any of that.
 */
export const MoneyInput = forwardRef<HTMLInputElement, {
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  id?: string;
  placeholder?: string;
}>(function MoneyInput({ value, onChange, autoFocus, id, placeholder = '0.00' }, ref) {
  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-500">$</span>
      <input
        ref={ref}
        id={id}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        autoFocus={autoFocus}
        className="field pl-7 text-lg font-medium"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          // Keep only digits and a single dot; strip commas and currency signs
          // so pasting from a bank statement works.
          const cleaned = e.target.value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
          const [whole = '', frac] = cleaned.split('.');
          onChange(frac === undefined ? whole : `${whole}.${frac.slice(0, 2)}`);
        }}
      />
    </div>
  );
});
